import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import router from '@/router';
import { route } from '@/api/apiRoute';

// create an axios instance
const service = axios.create({
    baseURL: route,
    withCredentials: false, // send cookies when cross-domain requests
    timeout: 500 * 1000, // request timeout
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
})

// request interceptor
service.interceptors.request.use(
    config => {
        if (localStorage.token) {
            config.headers['Authorization'] = localStorage.token
        }
        if(localStorage.guid){
            if(config.data){
                config.data.tenantGuid = localStorage.guid
            } else if(config.params){
                config.params.tenantGuid = localStorage.guid
            }
        }
        return config
    },
    error => { 
        // do something with request error
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    response => {
        const res = response.data

        if (res.msg && res.msg.indexOf('已过期') > -1) {
            Message({
                message: res.message || 'Error',
                type: 'error',
                duration: 5 * 1000
            })
            localStorage.clear()
            router.replace({
                path: '/Login',
            });
        }

        // if the custom code is not 20000, it is judged as an error.
        // if (res.code !== 0000) {
        //     Message({
        //         message: res.message || 'Error',
        //         type: 'error',
        //         duration: 5 * 1000
        //     })

        //     // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
        //     if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        //         // to re-login
        //         // MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
        //         //     confirmButtonText: 'Re-Login',
        //         //     cancelButtonText: 'Cancel',
        //         //     type: 'warning'
        //         // }).then(() => {
        //         //     store.dispatch('user/resetToken').then(() => {
        //         //         location.reload()
        //         //     })
        //         // })
        //     }
        //     return Promise.reject(new Error(res.message || 'Error'))
        // } else {
            return res
        // }
    },
    error => {
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    localStorage.clear()
                    router.replace({
                        path: '/Login',
                        // query: {redirect: router.currentRoute.fullPath}//登录成功后跳入浏览的当前页面
                    });
                case 400:
                    Message({
                        message: error.response.data.msg ? error.response.data.msg : error.response.data.data,
                        type: 'error',
                        duration: 5 * 1000
                    })
                    return Promise.reject(error)
                // Message.error(error.response.data.msg ? error.response.data.msg : error.response.data.data);
                // return;
                case 404:
                    Message({
                        message: '接口找不到！',
                        type: 'error',
                        duration: 5 * 1000
                    })
                    return Promise.reject(error)
                // return;
                case 500:
                    Message({
                        message: '接口报错！',
                        type: 'error',
                        duration: 5 * 1000
                    })
                    return Promise.reject(error)
            }
        }

    }
)

export default service